export const review = state => state.review



// WEBPACK FOOTER //
// ./src/store/getters.js